import { Action, createReducer, on } from '@ngrx/store';

import { salesProductsApiActions } from './sales-products.actions';
import { SalesProducts } from './sales-products.model';

export const SALES_PRODUCTS_FEATURE_KEY = 'salesProducts';

export interface SalesProductsState {
  salesProducts?: SalesProducts;
  loaded: boolean;
  error?: any;
}

export interface SalesProductsPartialState {
  readonly [SALES_PRODUCTS_FEATURE_KEY]: SalesProductsState;
}

export const initialSalesProductsState = { loaded: false };

const reducer = createReducer(
  initialSalesProductsState,
  on(salesProductsApiActions.loadSalesProducts, () => ({
    loaded: false,
    salesProducts: undefined,
    error: undefined,
  })),
  on(salesProductsApiActions.loadSalesProductsSuccess, (state, { salesProducts }) => ({
    ...state,
    salesProducts,
    loaded: true,
  })),
  on(salesProductsApiActions.loadSalesProductsFailure, (state, { error }) => ({ ...state, error, loaded: true }))
);

export const salesProductsReducer = (state: SalesProductsState | undefined, action: Action) => reducer(state, action);
